export default function PHP_str_split() {
  return (
    <div>
      <h1>PHP_str_split</h1>
    </div>
  );
}
